/**
 * The feature's route table, mounted at /settings/guardrails/* — every view is
 * a real URL: the list, the batch add-rules workflow, the transient upload
 * review, and per-document pages by id.
 */
import { Route, Routes } from 'react-router-dom';
import { GuardrailsPage } from './GuardrailsPage.js';
import { AddRulesPage } from './AddRulesPage.js';
import { ReviewUploadPage } from './ReviewUploadPage.js';
import { PolicyViewPage } from './PolicyViewPage.js';
import { PolicyEditPage } from './PolicyEditPage.js';

export const GuardrailsRoutes = () => (
  <Routes>
    <Route index element={<GuardrailsPage />} />
    <Route path="add" element={<AddRulesPage />} />
    <Route path="review" element={<ReviewUploadPage />} />
    <Route path=":policyId" element={<PolicyViewPage />} />
    <Route path=":policyId/edit" element={<PolicyEditPage />} />
  </Routes>
);
